import React, { Component } from 'react'
import { Form, Row, Col } from 'react-bootstrap';
import { FormControl } from '../../../facturotopia';
import Validator from 'validatorjs';

class SocioDeNegocioUpsertForm extends Component {

  state = {}

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules)
    };
  }

  get rules() {
    return {
      razon_social: ['required'],
      email: ['required', 'email'],
      telefono: ['string'],
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const { step } = this.props;
    const data = {
      ...this.props.data,
      status: undefined,
      ...value
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      step,
      isValid: validator.passes()
    });
  }

  render() {
    const { data = {} } = this.props;
    const { validator } = this.state;

    return (
      <Form autoComplete="off">
        <Row>
          <Col xs={ 12 } sm={ 12 } md={ 6 } lg={ 5 }>
            <FormControl type="text"
              label="Razón social"
              name="razon_social"
              placeholder=""
              help=""
              validator={ validator }
              autoFocus={ true }
              value={ data.razon_social }
              onChange={ this.handleOnChange }
            />

            <FormControl type="text"
              label="Email"
              name="email"
              placeholder=""
              help="Se usará para enviarle la invitación"
              validator={ validator }
              value={ data.email }
              readOnly={ !!data.id }
              onChange={ this.handleOnChange }
            />

            <FormControl type="text"
              label="Teléfono"
              name="telefono"
              placeholder=""
              help="Este campo es opcional, se usará para información de contacto."
              validator={ validator }
              value={ data.telefono }
              onChange={ this.handleOnChange }
            />

          </Col>

        { this.props.children }

        </Row>

      </Form>
    )
  }
}

export default SocioDeNegocioUpsertForm;